import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "../i18n";
import { useSettings } from "../settings";

/**
 * Per-page SEO. Falls back to sensible defaults.
 * Props:
 *  - title (string, required)
 *  - description (string)
 *  - path (string, e.g. "/kurumsal")
 *  - image (string, absolute URL)
 */
const SEO = ({ title, description, path = "/", image }) => {
  const { lang } = useLang();
  const { settings } = useSettings();

  const brand = settings?.legal_name || "Koptur Grup A.Ş.";
  const fullTitle = title ? `${title} | ${brand}` : `${brand} | ${settings?.tagline || ""}`;
  const desc =
    description ||
    (lang === "tr"
      ? "Koptur Grup A.Ş. — Antalya merkezli inşaat, gayrimenkul, otomotiv, turizm, tarım ve enerji alanlarında faaliyet gösteren köklü Türkiye markası."
      : "Koptur Grup A.Ş. — a Turkish group operating in construction, real estate, automotive, tourism, agriculture and energy, headquartered in Antalya.");
  const origin =
    typeof window !== "undefined" && window.location ? window.location.origin : "";
  const url = `${origin}${path}`;
  const ogImage = image || `${origin}/brand/apple-touch-icon.png`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={lang === "tr" ? "tr_TR" : "en_US"} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
